import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';
import ImmutablePureComponent from 'react-immutable-pure-component';
import { connect } from 'react-redux';

import { Button } from 'mastodon/components/button';
import { IconButton } from 'mastodon/components/icon_button';
import ComposeFormContainer from 'mastodon/features/compose/containers/compose_form_container';
import { CloseIcon } from 'mastodon/components/icons/close';

const COMPOSE_MODAL_FORM_ID = 'compose-modal-form';

class ComposeFormModal extends ImmutablePureComponent {
  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
  };

  render() {
    const { onClose } = this.props;

    return (
      <div className='modal-root__modal compose-form-modal'>
        <div className='compose-form-modal__header'>
          <IconButton
            className='compose-form-modal__close'
            title=''
            icon='times'
            iconComponent={CloseIcon}
            onClick={onClose}
            size={20}
          />
          <div className='compose-form-modal__title'>
            <FormattedMessage id='status.create_post' defaultMessage='Create post' />
          </div>
          <Button
            type='submit'
            form={COMPOSE_MODAL_FORM_ID}
            compact
            className='compose-form-modal__publish'
            text={<FormattedMessage id='compose_form.publish' defaultMessage='Post' />}
          />
        </div>
        <div className='compose-form-modal__content'>
          <ComposeFormContainer autoFocus onClose={onClose} formId={COMPOSE_MODAL_FORM_ID} />
        </div>
      </div>
    );
  }
}

export default connect()(injectIntl(ComposeFormModal));
